<template>
    <div>
        <b-modal v-model="mostrarModal" @hidden="fecharModal" size="md" no-close-on-backdrop>
            <div slot="modal-title">
                Aprovar Item da Medição
            </div>
            <b-row>
                <b-col sm="12">
                    <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-alert show variant="warning">
                        <div class="text-dark">
                            <span class="font-weight-bold">Atenção</span> 
                            <div v-if="itemAprovadoFiscalTerceiro">
                                Essa ação irá submeter o item {{ descricaoItemBoletimMedicao }} para validação do fiscal de obras, você deseja continuar?
                            </div>
                            <div v-if="itemAprovadoFiscalObras">
                                Essa ação irá definir o item {{ descricaoItemBoletimMedicao }} como aprovado pelo fiscal de obras, você deseja continuar?
                            </div>
                        </div>
                    </b-alert>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal"
                    class="mr-2"
                >
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    @click.stop="aprovarItem"
                >
                    Aprovar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import BoletimMedicaoServicos from '../../../BoletimMedicaoServicos';
import { statusItemBoletimMedicaoEnum } from '../../../BoletimMedicao';

export default {
    props: {
        mostrarModal: {
            type: Boolean,
            default: false
        },
        itemBoletimMedicao: {
            type: Object,
            default: {},
        },
        contratoId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            erros: [],
        }
    },
    computed: {
        descricaoItemBoletimMedicao() {
            if (this.itemBoletimMedicao) 
                return `${this.itemBoletimMedicao.descricao}`;
            
            return '';
        },
        itemAprovadoFiscalTerceiro() {
            if (this.itemBoletimMedicao) 
                return this.itemBoletimMedicao.status == statusItemBoletimMedicaoEnum.AguardandoAprovacaoFiscalTerceiro;

            return '';
        },
        itemAprovadoFiscalObras() {
            if (this.itemBoletimMedicao) 
                return this.itemBoletimMedicao.status == null || this.itemBoletimMedicao.status == statusItemBoletimMedicaoEnum.AguardandoAprovacaoFiscalObras;

            return '';
        },
    },
    methods: {
        fecharModal() {
            this.$emit('fecharModal')
        },
        aprovarItem() {
            if (this.itemBoletimMedicao.status == statusItemBoletimMedicaoEnum.AguardandoAprovacaoFiscalTerceiro)
                this.aprovarItemBoletimMedicaoPeloFiscalTerceiro();
            else 
                this.aprovarItemBoletimMedicaoPeloFiscalObras();
        },
        aprovarItemBoletimMedicaoPeloFiscalTerceiro(){
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.aprovarItemBoletimMedicaoPeloFiscalTerceiro(
                this.contratoId, 
                this.itemBoletimMedicao.boletimMedicaoId, 
                this.itemBoletimMedicao.itemBoletimMedicaoId
            )
                .then(response => {
                    if (response.data.success) {
                        this.$toast.success(
                            'Item do Boletim de medição enviado para análise do fiscal de obras!',
                            'OK',
                            this.$toastConfig.success
                        );
                        
                        this.$emit('fecharModal');
                    } else {
                        this.erros = response.data.errors
                    }
                })
                .catch(error => {
                    this.erros = error.response.data.errors
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },
        aprovarItemBoletimMedicaoPeloFiscalObras(){
            this.$store.dispatch('addRequest')

            BoletimMedicaoServicos.aprovarItemBoletimMedicaoPeloFiscalObras(
                this.contratoId, 
                this.itemBoletimMedicao.boletimMedicaoId, 
                this.itemBoletimMedicao.itemBoletimMedicaoId
            )
                .then(response => {
                    if (response.data.success) {
                        this.$toast.success(
                            'Item do Boletim de medição aprovado pelo fiscal de obras!',
                            'OK',
                            this.$toastConfig.success
                        );
                        
                        this.$emit('fecharModal');
                    } else {
                        this.erros = response.data.errors
                    }
                })
                .catch(error => {
                    this.erros = error.response.data.errors
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },
    },
}
</script>